import React from 'react';

import { useIntl } from 'react-intl';

import { routes } from 'utils/routing';

import { OrderIssuesContainer, OrderIssuesHeading, OrderIssuesText, StyledLink } from './styled';

export const NeedHelp = ({ children }: { children: React.ReactNode }) => {
  const { formatMessage } = useIntl();

  return (
    <OrderIssuesContainer>
      <OrderIssuesHeading>{formatMessage({ id: 'needHelp' })}</OrderIssuesHeading>
      <OrderIssuesText>
        {formatMessage({ id: 'issuesDuringExperience' })}&nbsp;
        <StyledLink to={routes.support} isInline isUnderlined>
          {formatMessage({ id: 'visitSupport' }).toLowerCase()}
        </StyledLink>
      </OrderIssuesText>

      {children}
    </OrderIssuesContainer>
  );
};
